import { Hydratable } from "../../models/hydration/Hydratable";
import Model from "../../models/Model";

export { HydratableModelError };
type Props = {
  model: Hydratable<Model> | undefined;
};

const HydratableModelError = (props: Props) => {
  if (props.model) {
    return <span>Loading template data</span>;
  } else {
    return <span>No template selected</span>;
  }
};
